module.exports = __webpack_public_path__ + "static/media/15423193293221461105750 - Citizen Datasteward.2ad2f33b.jpg";